import React, { createContext, useReducer, useEffect } from 'react';
import PropTypes from 'prop-types';
import authReducer from '../reducers/authReducer';

export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const { children } = props;

  const [auth, dispatch] = useReducer(authReducer, [], () => {
    const localData = localStorage.getItem('auth');
    return localData ? JSON.parse(localData) : {};
  });

  useEffect(() => {
    localStorage.setItem('auth', JSON.stringify(auth));
  }, [auth]);

  return (
    <AuthContext.Provider value={{ auth, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;

AuthContextProvider.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.object.isRequired,
};
